import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-global-select-category]';
const PLUGIN_NAME = 'GlobalSelectCategory';

const log = debug('global-select-category');

class GlobalSelectCategory {
	constructor(element, options) {

		this.options = options;
		this.element = element;
        this.select= this.element.querySelector('select');

		this.watch();

		log('ready', this);
	}

	watch() {
		log('watching');
        this.element.addEventListener('submit', this.onSubmit.bind(this));

	}

    onSubmit()
    {
        var selectedCategory = this.select.value;
		this.element.action = selectedCategory;

    }

}

GlobalSelectCategory.DEFAULTS = {};

plugin(PLUGIN_NAME, GlobalSelectCategory);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/search/global-search/global-select-category.js